import { Box, Text, ToggleCard } from '@zillow/constellation-10';

import type { ReactElement } from 'react';

interface AnswerCardProps {
  icon: ReactElement;
  title: string;
  isSelected?: boolean;
  onClick?: () => void;
  'data-testid'?: string;
}

const AnswerCard = ({ icon, title, isSelected = false, onClick, 'data-testid': dataTestId }: AnswerCardProps) => {
  return (
    <ToggleCard
      data-testid={`AnswerCard ${dataTestId}`}
      selected={isSelected}
      onSelectedChange={() => onClick?.()}
      tone="neutral"
      outlined
      elevated={false}
      dividers={false}
      css={{
        borderRadius: '400',
        ...(isSelected && {
          // match the color of the hover state of the card
          backgroundColor: '{colors.bg.action.neutral.alt.hover}',
        }),
      }}
    >
      <Box css={{ display: 'flex', alignItems: 'center', gap: '400' }}>
        <Box css={{ flexShrink: 0, color: 'icon.accent.brand.hero' }}>{icon}</Box>
        <Text textStyle="body-bold">{title}</Text>
      </Box>
    </ToggleCard>
  );
};

export default AnswerCard;
